import React from "react";
import { Row, Col } from "react-bootstrap";
import CardHeader from "../../../components/CardHeader";
import { COLOR_DEATHS } from "../../../GlobalColors";

interface PresumptiveCountsProps {
  data: App.ProbableElement;
}

export default function PresumptiveCounts(props: PresumptiveCountsProps) {
  const { data } = props;
  return (
    <>
      <Col className="m-presumptive card h-100">
        <CardHeader
          title="Probable COVID-19 Counts"
          toolTipText="Indiana defines probable COVID-19 counts when a physician listed COVID-19 as a contributing cause of death for a patient but no COVID-19 positive test was documented on that individual. 
            The clinical diagnosis of COVID-19 can be made using the patient’s x-ray, CT scan of their chest, and the full clinical picture. Probable counts are not included in the total confirmed counts. 
            These counts are subject to change as additional lab data or information is reported to IDOH."
        />
        <Row className="mt-4 d-flex h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            className="align-self-center text-center"
          >
            <p className="h5">Total Probable Deaths</p>
            <h2 className="h1 font-weight-bold" style={{ color: COLOR_DEATHS }}>
              {data.probableDeaths}
            </h2>
          </Col>
        </Row>
      </Col>
    </>
  );
}
